import App from './App';
import UnifyApp from './v2/core/UnifyApp';
import { useEffect } from 'react';
import { useUnifyER, useUnifyVersion } from './AppState';
import UnifyERApp from './er/UnifyERApp';
import { toRelativeUrl } from "@okta/okta-auth-js";
import { useAllApplicationsStore } from './Store';

function MainApp() {

  const unifyVersion = useUnifyVersion((state: any) => state.unifyVersion);
  const unifyER = useUnifyER((state: any) => state.unifyER);

  const version = unifyVersion || "v1";
  const ER = unifyER || "false";
  const setDeepLinkProgress = useAllApplicationsStore((state:any) => state.setDeepLinkProgress);

  useEffect(() => {
    document.getElementById("qualtrics")?.remove();
    window.QSI?.API?.unload();

    try{
      if(window.location.pathname?.indexOf('/dp_') >= 0) {
        const deepLink = window.location.href.split('/dp_')[1];
        window.localStorage.setItem('deep-link-url', deepLink);
        setDeepLinkProgress(true);
      }
    } catch (error) {
      console.error('Error parsing deep link from /dp_:', error);
    }

    if(window.location.pathname?.indexOf('/bdp') >= 0) {
     
      try{
        let pid = '';
        let link = '';
        let obj = {id:'',url:''};
        try{
          obj = JSON.parse(atob(window.location.pathname.split('/bdp')[1] || '{}'));
          pid = obj.id;
          link = obj.url;
        } catch(_) {
          link = window.location.pathname.split('/bdp')[1];
        }
        //const { id:pid, url:link } = JSON.parse(atob(window.location.pathname.split('/bdp')[1] || '{}'));
        const encLink = `/dp/${pid}/${link}`;
        if(pid && link) {
          window.localStorage.setItem('deep-link-url', encLink);
          setDeepLinkProgress(true);
        }
      } catch (error) {
        console.error('Error parsing deep link from /bdp:', error);
      }     
    }
    
  }, [version, setDeepLinkProgress])

  useEffect(() => {
  if(ER === 'true' 
    && !window.location.pathname.includes('/login/callback')
    && !window.location.pathname.includes('/er-unify')){
      const url = toRelativeUrl("/er-unify", window.location.origin);
      window.location.href=url;
    }
  },[ER])

    useEffect(() => {
    if(ER === 'false' && version === 'v2'
      && !window.location.pathname.includes('/login/callback')
      && !window.location.pathname.includes('/unify')){
        const url = toRelativeUrl("/unify", window.location.origin);
        window.location.href=url;
      }
  },[ER,version])

  return (
    <>
        {ER === 'true' && <UnifyERApp></UnifyERApp>}
        {ER === 'false'  && version === 'v1' && <App></App>}
        {ER === 'false'  && version === 'v2' && <UnifyApp></UnifyApp> }
    </>
  );
}
export default MainApp;